import React from 'react'

import { SOPDocument } from '@/features/sop-drawer'
import { useStandardOperatingProcedureQuery } from '@/graphql/generated/hooks'
import { useAppDispatch } from '@/redux/hooks'
import { setSOPIncidentId } from '@/redux/ui/uiSlice'

import { SOPDrawerHeader } from './SOPDrawerHeader'

export const SOPIncidentDetail = ({ id }: { id: string }) => {
  const dispatch = useAppDispatch()
  const { data, loading: isLoading } = useStandardOperatingProcedureQuery({
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  })

  const onClose = () => {
    dispatch(setSOPIncidentId({ id: null }))
  }

  return (
    <>
      <SOPDrawerHeader
        isLoading={isLoading}
        onClose={onClose}
        sop={data?.standardOperatingProcedure}
      />
      <SOPDocument
        isLoading={isLoading}
        sop={data?.standardOperatingProcedure}
      />
    </>
  )
}
